<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 31 31">
  <rect width="31" height="31" fill="#15b078" />
  <path fill="#fff" fill-rule="evenodd" d="m24 7-12.75 3.825L7 24l13.175-3.825L24 7Zm-8.5 10.625a2.125 2.125 0 1 0 0-4.25 2.125 2.125 0 0 0 0 4.25Z" clip-rule="evenodd"/>
</svg>
